// store/modules/device.js
import { debounce } from 'lodash'
import router from '@/router'
// 判断设备类型（UA + 窗口宽度）
const getDeviceClass = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isMobileUA = /mobile|android|iphone|ipad|phone/i.test(ua)
  const isMobileSize = window.innerWidth < 768

  return isMobileUA || isMobileSize ? 'h5' : 'pc'
}

export default {
  namespaced: true,
  state: () => ({
    deviceClass: getDeviceClass() // 直接存储设备类型
  }),
  mutations: {
    // 更新设备类型的 mutation
    UPDATE_DEVICE_CLASS(state) {
      state.deviceClass = getDeviceClass()
    }
  },
  actions: {
    // 初始化监听窗口变化
    initResizeListener({ commit }) {
      const handleResize = debounce(() => {
        commit('UPDATE_DEVICE_CLASS')
        //H5屏幕尺寸变化后需要刷新页面重置滑块
        if (router.currentRoute.name === 'register') {
          // window.location.reload()
        }
      }, 500) // 防抖

      window.addEventListener('resize', handleResize)
      window.addEventListener('orientationchange', handleResize) // 处理移动端旋转
    }
  },
  getters: {
    deviceClass: state => state.deviceClass
  }
}
